var XPortal = XPortal || {};
XPortal.Loader = (function () {
    var loader = {};

    var options = {
        selector: null,
        showOverlay: false,
        size: '4rem',
        showDelayTime: 1000,
        autoHideTime: 0,
        isInline: false,
        color: undefined,
        bgcolor: undefined,
        overlayBgColor: undefined
    };

    loader.timeout = new Array();

    function getWrapper(settings) {
        var o = $.extend({}, options, settings);
        o = $.extend(settings, o);
        if (o.selector == null) o.selector = 'body';
        var $wrapper = (o.selector instanceof jQuery) ? o.selector : $(o.selector);
        if ($wrapper.length) return $wrapper;
        return null;
    }

    loader.show = function (settings) {
        var $wrapper = getWrapper(settings);
        if (!!!($wrapper)) return;
        var $loader = settings.selector == 'body' ? $wrapper.children('.loader') : ($wrapper.hasClass('loader') ? $wrapper : $wrapper.find('.loader'));
        if (!$loader.length) {
            $wrapper.append('<div class="loader hidden loader-created"><div class="loader-spinner"><div class="loader-spinner-l"></div><div class="loader-spinner-r"></div></div></div>');
            $loader = $wrapper.find('.loader');
        }
        loader.clear($wrapper, true);
        $loader.attr('title', '');
        var position = $wrapper.css('position');
        if (position != 'absolute' && position != 'fixed' && position != 'relative') {
            $wrapper.addClass('loader-wrapper-relative');
        }

        var key = XPortal.Utils.makeRandomString(10);
        $loader.attr('data-key', key);
        loader.timeout[key] = setTimeout(function () {
            $loader.attr('data-bg', settings.showOverlay).removeClass('hidden');
        }, settings.showDelayTime);

        if (settings.isInline === 'true' || settings.isInline === 'True' ? true : (settings.isInline === 'false' || settings.isInline === 'False' ? false : settings.isInline)) {
            $loader.addClass('loader-inline');
        }

        var $spinner = $loader.find('.loader-spinner');
        var $spinnerHourglass = $spinner.find('.loader-spinner-l, .loader-spinner-r');

        if (typeof settings.size != 'undefined') {
            $spinner.css({ 'width': settings.size, 'height': settings.size, 'min-width': settings.size, 'min-height': settings.size });
        }

        if (typeof settings.bgcolor != 'undefined') {
            $spinner.css({ 'border-color': settings.bgcolor });
            $spinnerHourglass.css({ 'background-color': settings.bgcolor });
        }

        if (typeof settings.overlayBgColor != 'undefined') {
            $loader.css({ 'background-color': settings.overlayBgColor });
        }
        
        if (typeof settings.color != 'undefined') {
            $spinner.css({ 'border-top-color': settings.color });
            $spinnerHourglass.css({ 'color': settings.color });
        }

        if (!isNaN(settings.zindex)) {
            $spinner.css({ 'z-index': settings.zindex });
        }

        if (settings.autoHideTime > 0) {
            setTimeout(function () {
                loader.hide({ selector: settings.selector });
            }, settings.autoHideTime);
        }

        let root = document.documentElement;
        let loaderImgUrl = getComputedStyle(root).getPropertyValue('--main_LoaderImgUrl').trim();
        let clearloaderImgUrl = loaderImgUrl.replace(/"/g, '');
        if (clearloaderImgUrl.length > 0) {
            $loader.addClass('image-loader');
        } else {
            $loader.removeClass('image-loader');
        }
        return $loader;
    };

    loader.message = function (settings, text, ttip) {
        var $wrapper = getWrapper(settings);
        if (!!!($wrapper)) return;

        var $loader = settings.selector == 'body' ? $wrapper.children('.loader') : $wrapper.find('.loader');
        var $txt = $loader.find('.loader-text');
        if ($txt.length == 0) {
            $txt = $('<span class="loader-text"><!----></span>'); $txt.appendTo($loader);
        }
        $txt.html(text);
        if (ttip) $loader.attr('title', ttip);
    };

    loader.hide = function (settings) {
        var $wrapper = getWrapper(settings);
        if (!!!($wrapper)) return;
        setTimeout(function () {
            loader.clear($wrapper, false);
        }, 1);
    };

    loader.clear = function (obj, isNew) {
        obj.removeClass('loader-wrapper-relative');
        var $loader = obj.hasClass('loader') ? obj : obj.closest_all('.loader');
        $loader.addClass('hidden')
            .removeClass('loader-inline')
            .removeAttr('data-bg')
            .removeAttr('style')
            .removeAttr('title')
            .stop();

        obj.find('.loader-text').remove();
        obj.find('.loader-spinner').removeAttr('style');

        $loader.each(function () { 
            clearTimeout(loader.timeout[$(this).attr('data-key')]);
        });

        !isNew && $loader.filter('.loader-created').remove();
    };

    return loader;
}());